import { render, staticRenderFns } from "./delayoutadd.vue?vue&type=template&id=76dfc376"
import script from "./delayoutadd.vue?vue&type=script&lang=js"
export * from "./delayoutadd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports